import type { BridgePin } from '../../../embed/MapBridge';
import { isCategoryCubePin } from './MapCategoryPinNode';
import { isDecisionPin } from './MapDecisionPinNode';
import { isGorgeStackPin } from './MapPoiStackPinNode';

export type MapMarkerKind = 'decision' | 'stack' | 'category-cube' | 'icon-plate' | 'species-media' | 'default';

/** Exclusive marker selection shared by curated and streamed map renderers. */
export function classifyMapMarker(pin: BridgePin): MapMarkerKind {
    if (isDecisionPin(pin)) return 'decision';
    if (isGorgeStackPin(pin)) return 'stack';
    if (isCategoryCubePin(pin)) return 'category-cube';
    if (pin.kind === 'poi' && !!pin.iconUrl) return 'icon-plate';
    if (pin.kind === 'species' && !!pin.thumbnailUrl) return 'species-media';
    return 'default';
}
